export function searchFormMobile() {
  const container = document.querySelector('[data-search-container]');
  if (container) {
    const searchButton = container.querySelector('[data-open-search]');
    const searchForm = container.querySelector('[data-search-block]');
    const cancelButton = container.querySelector('[data-search-cancel]');

    searchButton.addEventListener('click', (event) => {
      event.preventDefault();
      searchForm.classList.add('is-active');
      document.documentElement.setAttribute('style', 'overflow:hidden');
    });
    cancelButton.addEventListener('click', (event) => {
      event.preventDefault();
      searchForm.classList.remove('is-active');
      document.documentElement.setAttribute('style', 'overflow:visible');
    });

    document.addEventListener('click', (event) => {
      if (!event.target.closest('[data-search-container]')) {
        searchForm.classList.remove('is-active');
        document.documentElement.setAttribute('style', 'overflow:visible');
      }
    });
  }
}
